module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e3bb24700ae7a04d4e31b04ec67ce189.png";